/**
 * Larghezza della sidebar dei filtri.
 *
 * Sotto la soglia mobile di Vuetify lo schermo e' stretto e il drawer si
 * restringe. Chi prenota lo spazio in attesa che il drawer nasca (nasce solo
 * dopo la -info della sezione) deve usare la stessa misura, altrimenti resta
 * una striscia vuota fra il contenuto e la sidebar finche' il drawer non
 * subentra.
 */
export function filtersDrawerWidth(vuetify) {
	return vuetify.breakpoint.mobile ? 300 : 380
}
